import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
export default function RequireAuth({ children }) {
  const { isAuthenticated } = useSelector((state) => state.userData.User);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
}
